import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/me'

const initialState = null

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  switch (action.type) {
    case actionTypes.SET_ME:
      return mergeState(action.me)
    case actionTypes.SET_CONTEXT:
      return mergeState({ context: action.context })
    case actionTypes.LOGOUT_ME:
      return {}
    default:
      return prevState
  }
}
